
import Title from "../../components/title";
import BlogListCard from "../../components/Blog/ListCard";
import helpers from "../../utils/helpers";
import urls from "../../constants/api-endpoints";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBlogList } from "../../store/CoreSlice";
import InfiniteLoader from "../../components/General/InfiniteLoader";
import { AxiosPromise } from "../../utils/axios";
import { MixpanelTracking } from "../../MixPanel";

export async function getServerSideProps(context: any) {
    let data = {}
    const routerParam = context.params.slug;
    const endPoint = helpers.getAPIEndpoint(urls.blogDetails, routerParam);

    const successHandler = (response : any) => {
        data = response.data;
    }

    const errorHandler = (error : any) => {
        console.log(error);
    }

    await AxiosPromise.requestGET(
        endPoint,
        {},
        {},
        successHandler,
        errorHandler
    )

    return {
        props: {
            data: data,
            param: routerParam
        }
    };
}

function BlogDetail({ data, param }: any) {
    const dispatch: any = useDispatch();
    const { blogList }: any = useSelector((state: any) => state.core);
    const currentPage = useRef(1); 

    useEffect(() => {
        const params = {
            page: 1,
            page_size: 30,
            exclude: param
        }
        dispatch(getBlogList(params));
        MixpanelTracking.getInstance().pageViewed({});
    }, []);

    // FUNCTIONS
    const getUserName = (blog: any) => {
        if (blog.created_by_user_instance_details)
            return blog.created_by_user_instance_details.name
        else if (blog.created_by)
            return blog.created_by;
        return 'Anonymous User'
    }

    const loadMoreBlogs = () => {                        
        currentPage.current = currentPage.current + 1;
        
        if(blogList.data.next) {
            dispatch(getBlogList({
                page : currentPage.current,
                page_size : 30,
                type : 'append'
            }));
        }
    }

    return (
        <>
            <Title title={data.title} />
            <div className="py-10">
                <div className="px-[20px] md:px-0 md:w-[60%] lg:w-[43%] md:mx-auto">
                    <h1 className="text-[36px] leading-[43px] text-center font-semibold"> {data.title} </h1>
                    <p className="text-center font-light mt-[24px] mb-[32px]"> {data.brief_description} </p>
                </div>

                <div className="w-full">
                    <img className="w-full h-[600px] object-cover" src={data.title_image} alt="Title Image" />
                </div>

                <div className="md:w-[50%] md:mx-auto lg:w-[40]">
                    <div className="h-[3px] w-[90%] mx-auto bg-[#000000] my-[24px] mb-[30px]" />

                    <div className="flex px-[20px]">
                        <img className="rounded-[50%] mr-[16px] w-[50px]" src="/Support/Profile.png" alt="Profile" />

                        <div className="text-[15px]">
                            <p> {getUserName(data)} </p>
                            <small className="font-light"> {data.blog_created_on} </small>
                        </div>
                    </div>

                    <div className={`px-[20px] py-[32px] unreset`} dangerouslySetInnerHTML={{ '__html': data.content }} />


                </div>

                {
                    blogList.list.length > 0 &&
                    <>
                        <div className="flex items-center">
                            <div className="h-[3px] bg-[black] w-[50%]" />
                            <img src="/TwoEyes.svg" alt="" className="w-[20%] md:w-[70px]" />
                            <div className="h-[3px] bg-[black] w-[50%]" />
                        </div>

                        <h2 className="text-[32px] text-center font-semibold my-[30px]">What to read next</h2>

                        <div className="
                            px-[20px] 
                            md:grid 
                            md:grid-cols-2 
                            lg:grid-cols-3 
                            gap-x-[30px] 
                            gap-y-[50px] 
                            md:w-[80%] 
                            lg:w-[70%] 
                            md:mx-auto"
                        >
                            {
                                blogList.list.map((blog: any) => (
                                    <div key={blog.id} className="mb-[40px] md:mb-0 cursor-pointer">
                                        <BlogListCard data={blog} />
                                    </div>
                                ))
                            }

                            {
                                blogList.data.next && true &&
                                <div className="text-center mt-10">
                                    <InfiniteLoader
                                        show={blogList.data.next && true}
                                        message={"Loading More..."}
                                        actionOnShow={loadMoreBlogs}
                                        extras={blogList}
                                    />
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default BlogDetail